/**
 * Вычисление пути, который вместиться в указанную ширину containerWidth. Если путь не вмещается, то начало пути заменяется на '...'
 */
const calculateVisiblePaths = (paths: string[], containerWidth: number, separator: string = ' / '): string[] => {
  let currentWidth = 0
  const result: string[] = [] // Массив для хранения видимых путей
  const widthSeparator = calculateTextWidth(separator)

  // Проходим по массиву путей с конца
  for (let i = paths.length - 1; i >= 0; i--) {
    const partialPath = paths[i]
    const partialWidth = calculateTextWidth(partialPath) + (i > 0 ? widthSeparator : 0) // Ширина пути с учетом разделителя

    // Если добавление пути в общий результат приведет к превышению ширины контейнера
    if (currentWidth + partialWidth > containerWidth) {
      result.unshift('…')
      break
    }

    currentWidth += partialWidth // Увеличиваем текущую ширину на размер текущего пути
    result.unshift(partialPath)
  }

  return result
}

/**
 * Подсчет ширины текста с учетом шрифта(по умолчанию 14px Inter).
 * */
const calculateTextWidth = (text: string, fontStyle = '14px Inter'): number => {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  if (!context) return 0
  context.font = fontStyle
  const textWidth = context.measureText(text).width

  canvas.remove()
  return textWidth
}

/**
 * Получение полного пути от родительского элемента до текущего элемента.
 */
const getPathsGroup = <ID extends string | number, T extends { id: ID; parentId: ID | null;[key: string]: any }>(
  id: ID,
  groups: T[],
  getName: (group: T) => string  // Функция, которая получает имя группы
): string[] => {
  const res: string[] = []
  const group = groups.find((group) => group.id === id)

  if (group) {
    res.push(getName(group))
    const parentPaths = getPathsGroup(group.parentId, groups, getName) // Рекурсивно вызываем функцию для родительской группы
    return [...parentPaths, ...res] // Собираем путь, начиная от корня и заканчивая текущей группой
  }

  return res // Возвращаем пустой путь, если группа не найдена
}

const breadcrumbPathsUtils = {
  calculateVisiblePaths,
  getPathsGroup,
}

export default breadcrumbPathsUtils
